import { makeStyles } from "@material-ui/core";
import background from "./../../assets/images/background.png";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url('${background}')`,
    backgroundSize: "120% 102%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    display: "block",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(6.5, 6, 2, 6),
    width: "100%",
    height: "100vh",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoWrapper: {
    maxWidth: "122px",
    display: "flex",
  },
  descLogoWrapper: {
    maxWidth: "254px",
  },
  logo: {
    width: "100%",
    objectFit: "contain",
  },
  description: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "16px",
    lineHeight: "22px",
    color: theme.palette.background.default,
    opacity: 0.4,
    margin: theme.spacing(2, 0, 6, 0),
  },
  message: {
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.palette.background.default,
    textAlign: "center",
  },
  list: {
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
    margin: 0,
  },
  listItem: {
    display: "flex",
    padding: theme.spacing(2, 5),
  },
  secondaryLink: {
    color: theme.palette.background.default,
    fontWeight: 600,
    fontSize: "16px",
    letterSpacing: "normal",
    lineHeight: "22px",
  },
}));
